import React from 'react';

import { Button, Popup, PopupSection, Text } from '@flixbus/honeycomb-react';

import BreakdownDetails from 'common/BreakdownDetails';

import { buildSectionsFromBreakdown } from './derive/buildSectionsFromBreakdown';
import { BREAKDOWN_DETAILS_MODAL_TEXT } from './text';

import styles from './styles.module.css';

/**
 * Read-only modal that shows the summary of an accepted `Breakdown`. Same
 * accordion layout as the flow's Summary step (shares `<BreakdownDetails>`
 * view), but sections are derived from the GraphQL `Breakdown` shape rather
 * than the flow draft.
 *
 * @param {{
 *   breakdown: object,
 *   segment?: { fromStation: object, toStation: object } | null,
 *   onClose: () => void,
 * }} props
 *   `segment` — the from → to pair at which the breakdown happened.
 *   Backend does not carry it on `Breakdown`; the caller resolves it via
 *   `common/BreakdownDetails/deriveBreakdownSegment` and forwards it here.
 */
const BreakdownDetailsModal = ({ breakdown, segment = null, onClose }) => {
	const sections = buildSectionsFromBreakdown(breakdown, { segment });

	return (
		<Popup id="modal-breakdown-details" active onOverlayClick={onClose}>
			<PopupSection type="title">{BREAKDOWN_DETAILS_MODAL_TEXT.title}</PopupSection>
			<PopupSection type="content">
				<Text extraClasses={styles.subtitle}>{BREAKDOWN_DETAILS_MODAL_TEXT.subtitle}</Text>
				<BreakdownDetails sections={sections} />
			</PopupSection>
			<PopupSection type="actions" extraClasses={styles.footer}>
				<Button appearance="primary" onClick={onClose} data-testid="breakdown-details-modal-close">
					{BREAKDOWN_DETAILS_MODAL_TEXT.close}
				</Button>
			</PopupSection>
		</Popup>
	);
};

export default BreakdownDetailsModal;
